import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TreetopPropertiesProvider } from 'shared/util-common';

import { CodingSystemResponse, CodingSystemDto } from '@treetop/shared/model';

@Injectable({
  providedIn: 'root',
})
export class CodingSystemsHttpService {
  private http = inject(HttpClient);

  private baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api/util`;

  public get(): Observable<CodingSystemDto[]> {
    return this.http.get<CodingSystemResponse>(`${this.baseUrl}/coding-systems`).pipe(map((response) => response.codingSystems || []));
  }
}
